/** The Add note action element. */
import { MetadataEntityFieldEditorType, MetadataEntityFieldType } from '../../../metadata/entity/decorators/model/metadata.entity.field.types';
import { WorkflowActionType } from '../workflow.definition';
import { WorkflowElement, WorkflowFamily, WorkflowFieldRenderer, WorkflowSideEffect } from '../workflow.element';

/** Adds a note activity to the run's Job. */
export const ADD_JOB_NOTE_ELEMENT: WorkflowElement = {
    type: WorkflowActionType.AddJobNote,
    family: WorkflowFamily.Job,
    sideEffect: WorkflowSideEffect.Write,
    title: 'Add a note to the Job',
    icon: 'fa-note-sticky',
    fields: [
        {
            bind: 'input.title',
            renderer: WorkflowFieldRenderer.MergeText,
            recordTags: true,
            metadata: {
                displayName: 'Title',
                type: MetadataEntityFieldType.String,
            },
        },
        {
            bind: 'input.body',
            required: true,
            renderer: WorkflowFieldRenderer.MergeText,
            recordTags: true,
            metadata: {
                displayName: 'Note',
                type: MetadataEntityFieldType.String,
                // A note body is rich text, as an email body is; the title stays one plain line.
                editor: MetadataEntityFieldEditorType.RichText,
            },
        },
    ],
    outputs: [
        { path: 'activityId', metadata: { displayName: 'Note ID', type: MetadataEntityFieldType.String } },
    ],
};
